// extracted by mini-css-extract-plugin
export var checkbox = "_22-0";
export var circle = "_22-3";
export var horizontalContainer = "_22-7";
export var sm = "_22-5";
export var switch0 = "_22-2";
export var switchDisabled = "_22-8";
export var switchEnabled = "_22-1";
export var textSwitchContainer = "_22-9";
export var textSwitchOption = "_22-a";
export var textSwitchOptionSelected = "_22-b";
export var verticalContainer = "_22-6";
export var xs = "_22-4";